import ProjectCard from './ProjectCard.container'

export default ProjectCard
